import React from 'react';
import { icons } from './adminSidebarIcons';
import { useModerationContext } from '../contexts/ModerationContext';

const sections = [
  { key: 'perfil', label: 'Perfil' },
  { key: 'mis-preguntas', label: 'Mis Preguntas' },
  { key: 'formulario', label: 'Formulario', userOnly: true },
  { key: 'estadisticas-publicas', label: 'Estadisticas', userOnly: true },
  { key: 'juego-diario', label: 'Concurso', userOnly: true },
  { key: 'introduccion-directa', label: 'Introducción Directa', adminOnly: true },
  { key: 'revision-preguntas', label: 'Revisión', adminOnly: true },
  { key: 'gestion-preguntas', label: 'Banco Preguntas', adminOnly: true },
  { key: 'moderacion-usuarios', label: 'Moderación', adminOnly: true },
  { key: 'estadisticas-publicas', label: 'Estadisticas', adminOnly: true },
  { key: 'inicio-concurso', label: 'Concurso', adminOnly: true },
];

const AdminSidebar = ({ activeTab, setActiveTab, userRole, onNavigate }) => {
  const { pendingQuestionsCount } = useModerationContext();
  
  const handleTabClick = (key) => {
    setActiveTab(key);
    if (onNavigate) onNavigate();
  };

  return (
    <nav className="h-full w-full bg-white dark:bg-gray-900 shadow-lg z-30 flex flex-col border-r border-gray-200 dark:border-gray-800">
      <div className="py-6 px-4 text-xl font-bold text-blue-700 dark:text-blue-300 border-b border-gray-200 dark:border-gray-800">
        Admin
      </div>
      <ul className="flex-1 py-4 px-2 space-y-2">
        {sections.map(section => {
          if (section.adminOnly && userRole !== 'admin' && userRole !== 'moderador') return null;
          if (section.userOnly && userRole !== 'usuario') return null;
          return (
            <li key={section.key}>
              <button
                className={`w-full flex items-center gap-3 text-left px-4 py-2 rounded-lg transition-colors font-medium text-base group relative ${activeTab === section.key ? 'bg-blue-100 dark:bg-blue-800 text-blue-700 dark:text-blue-200' : 'text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800'}`}
                onClick={() => handleTabClick(section.key)}
              >
                <span className="flex-shrink-0 text-xl">{icons[section.key]}</span>
                <span
                  className={`transition-transform duration-200 group-hover:translate-x-1 group-hover:scale-105 ${activeTab === section.key ? 'font-bold' : ''} 
                    truncate max-w-full leading-tight
                    ${section.label.length > 13 ? 'text-sm' : 'text-base'}`}
                  title={section.label}
                >
                  {section.label}
                </span>
                {/* Badge para "Revisión" si hay preguntas pendientes */}
                {section.key === 'revision-preguntas' && pendingQuestionsCount > 0 && (
                  <span className="ml-auto flex-shrink-0 inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 rounded-full animate-pulse">
                    {pendingQuestionsCount}
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default AdminSidebar;
